export enum PaymentType {
  CREDIT = "credit",
  DEBIT = "debit",
}
